<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <!-- <div class="" style="color:red;margin-bottom: 10px;font-size: 12px;">红色为一个月内操作过</div> -->
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
               
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="发送用户" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.nickName }}
                        <div>
                            ({{ scope.row.sendGender==1?'男':'' }}{{ scope.row.sendGender==2?'女':'' }})
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="isRead" label="发送用户类型" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.isRead?'*':'' }}
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="sendPhone" label="发送手机" align="center" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.sendPhone }}
                        <span :style="'color:'+(scope.row.state==1?'#409eff':'#f56c6c')">
                            ({{ scope.row.state==-3?'拉黑':'' }}
                            {{ scope.row.state==-2?'注销':'' }}
                            {{ scope.row.state==-1?'冻结':'' }}
                            {{ scope.row.state==0?'审核中':'' }}
                            {{ scope.row.state==1?'正常':'' }})
                        </span>
                    </template>
                </el-table-column>
              
                <el-table-column prop="sendCity" label="发送城市" align="center"></el-table-column>
                <el-table-column prop="message" label="消息内容" align="center" width="250"></el-table-column>
                <el-table-column prop="toNickName" label="接收用户" align="center" >
                    <template slot-scope="scope">
                        <span :style="!scope.row.oneMonthOperate&&scope.row.toIsReal?'color:red':''">
                            {{ scope.row.toNickName }}{{ scope.row.toIsReal?'*':'' }}
                            <span>
                                ({{ scope.row.toGender==1?'男':'' }}
                                {{ scope.row.toGender==2?'女':'' }})
                            </span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="toIsReal" label="接收用户类型" align="center" width="120">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.toIsReal?'*':'' }}
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="toPhone" label="接收手机" align="center" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.toPhone }}
                        <span :style="'color:'+(scope.row.toState==1?'#409eff':'#f56c6c')">
                            ({{ scope.row.toState==-3?'拉黑':'' }}
                            {{ scope.row.toState==-2?'注销':'' }}
                            {{ scope.row.toState==-1?'冻结':'' }}
                            {{ scope.row.toState==0?'审核中':'' }}
                            {{ scope.row.toState==1?'正常':'' }})
                        </span>
                    </template>
                </el-table-column>
                
                <el-table-column prop="toCity" label="接收城市" align="center"></el-table-column>
                <el-table-column prop="sendTime" label="发送时间" align="center" width="160px"></el-table-column>
                <!-- <el-table-column prop="isRead" label="是否已读" align="center" width="80px">
                    <template slot-scope="scope">
                        {{ scope.row.isRead?'是':'否' }}
                        <span>
                            {{ !scope.row.isRead?'('+scope.row.xday+'天)':''}}
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="dongjieTip(scope.row)">冻结用户</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="addBacktTip(scope.row)">加入黑名单</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="addMsgTip(scope.row)" v-if="accessUserName=='13750415123'">发送消息</el-button>
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="sendztmphy(scope.row)">发送短信</el-button> -->
                    <!-- <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="dynamicNumberDialog(scope.row)">发布动态次数</el-button> -->
                    <!-- <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="isDetailDialogShow(scope.row)">查看详情</el-button> -->
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isFrozenDialog" :title="'冻结用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        冻结原因
                    </div>
                    <div class="valuet">
                        <el-input v-model="frozenData.reason" size="small" placeholder="请输入" type="textarea" :rows="4"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="dongjie()">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddBackDialog" title="加入黑名单" width="720px">
            <div class="dialog">
                
                <div class="item">
                    <div class="label">
                        原因
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="addBackData.reason" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
                
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="LaHei()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="addMsgDialog" title="回复消息" width="1000px">
            <div class="dialog">
                <div class="list">
                    <el-table
                        :data="detailMsgList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width: 100%">
                        <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                        <el-table-column prop="nickName" label="发送用户" align="center"></el-table-column>
                        <el-table-column prop="message" label="消息内容" align="center" width="250"></el-table-column>
                        <el-table-column prop="toNickName" label="接收用户" align="center" ></el-table-column>
                        <el-table-column prop="creationTime" label="发送时间" align="center" width="160px"></el-table-column>
                    </el-table>
                </div>
                <div class="item">
                    <div class="label">
                        发送用户:
                    </div>
                    <div class="value" style="width:400px">
                        <el-radio v-model="userId" :label="toUserId">{{toNickName}}</el-radio>
                        <el-radio v-model="userId" :label="sendUserId">{{nickName}}</el-radio>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        消息
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="addMsgData.content" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="addMsg()">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                sendCity:'',
                sendPhone:'',
                sendGender:'',
                toPhone:'',
                is_real: true,
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "发送用户账号:",name: "sendPhone"},
                {type: "input",label: "发送者所在城市:",name: "sendCity"},
                {type: "select",label: "发送者性别:",name: "sendGender",options:[{
                    label:'男',
                    value:1
                },{
                    label:'女',
                    value:2
                }]},

                {type: "input",label: "接受用户账号:",name: "toPhone"},
                {type: "input",label: "接收者所在城市:",name: "toCity"},
                
            ],
            frozenData:{
                "userId": null,
                "reason": ""
            },
            isFrozenDialog:false,
            isAddBackDialog:false,
            addBackData:{
                "userId": null,
                "reason": ""
            },
            addMsgData:{
                "sendUserId": 0,
                "toUserId": 0,
                "content": ""
            },
            addMsgDialog:false,

            detailMsgList:[],
            sendUserId:'',
            toUserId:'',
            nickName:'',
            toNickName:'',
            userId:'',
            addMsgqueryData:{},
            accessUserName:'',
            
        }
    },
    created(){
        
        if(localStorage.getItem('accessUserName')){
            this.accessUserName = localStorage.getItem('accessUserName')
            
        }
    },
    mounted(){
        if(localStorage.getItem('chatCon')){
            this.conditionData = JSON.parse(localStorage.getItem('chatCon'));
            this.totalCount = this.conditionData.page*10
            this.$forceUpdate();
        }

        this.loadingData();
    },
    methods:{
        
        // 冻结提示
        dongjieTip(item){
            this.username = item.nickName
            this.frozenData.userId = item.sendUserId;
            this.isFrozenDialog =true;
        },
        async dongjie(){
            let res = await api.AdminStandFrozen(this.frozenData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.isFrozenDialog =false;
                this.loadingData();
            }
        },
        addBacktTip(row){
           
            this.addBackData = {
                userId:row.sendUserId,
                phone: row.sendPhone,
                nickName: row.nickName,
                weChat: row.weChat,
                device: row.device,
                reason:'',
            }
            this.isAddBackDialog = true;
        },
        async addMsgTip(row,isEdit){
            if(!isEdit){
                this.userId = row.toUserId
            }
            let res = await api.QueryChatMsgConversation({snapMsgId:row.id});
            this.nickName = row.nickName;
            this.toNickName = row.toNickName;
            this.sendUserId = row.sendUserId;
            this.toUserId = row.toUserId;
            this.detailMsgList = []
            for(let i = (res.data.data.length-1);i>=0;i-- ){
                this.detailMsgList.push(res.data.data[i])
            }
            this.addMsgqueryData = row;
           
            this.addMsgDialog = true;
        },
        async addMsg(){
            if(this.userId == this.toUserId){
                this.addMsgData.sendUserId = this.toUserId;
                this.addMsgData.toUserId = this.sendUserId;
            }else{
                this.addMsgData.sendUserId = this.sendUserId;
                this.addMsgData.toUserId = this.toUserId;
            }
           
            let res = await api.AddChatMsg(this.addMsgData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '回复成功'
                }); 
                this.addMsgData.content = '';
                // this.addMsgDialog = false;
                // this.loadingData();
                this.addMsgTip(this.addMsgqueryData,true);

            }
        },
        async sendztmphy(row){
             this.$confirm('确认向'+row.toPhone+'发送短信?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sendMsg(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
            
        },
        async sendMsg(row){
            let res = await api.Sendztmphy_tpl103099({phone:row.toPhone});
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '发送成功'
                }); 
                
            }
        },
        async LaHei(){
            let res = await api.LaHei(this.addBackData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                }); 
                this.isAddBackDialog = false;
                this.loadingData();

            }
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            if(this.accessUserName != '13750415123'){
                this.conditionData.is_real = true
            }else{
                this.conditionData.is_real = null
            }
            let res  = await api.ChatMsgQueryChatMsg(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            localStorage.setItem('chatCon',JSON.stringify(this.conditionData));
            this.loadingData();
        },
        // 重置查询
        reset(){
            localStorage.removeItem('chatCon');
            if(this.accessUserName == '13750415123'){
                this.conditionData = {
                    sendCity:'',
                    sendPhone:'',
                    sendGender:'',
                    toPhone:'',
                    is_real: null,
                    current:1,
                    size:10,
                }
            }else{
                this.conditionData = {
                    sendCity:'',
                    sendPhone:'',
                    sendGender:'',
                    toPhone:'',
                    is_real: true,
                    current:1,
                    size:10,
                }
            }
            
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            localStorage.setItem('chatCon',JSON.stringify(this.conditionData));
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.current = 1;
            this.conditionData.size = pageSize;
            this.loadingData();
        },
        
      
        
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    ::v-deep .table-expand {
        font-size: 0;
    }
    .row{
        display: flex;
    }
    ::v-deep .table-expand label {
        width: 200px;
        padding-left: 50px;
        color: #99a9bf;
    }
    ::v-deep .table-expand span {
        color: #222222;
    }
    ::v-deep .table-expand .btn span{
        color: #409eff;
    }
    ::v-deep .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .valuet{
                width: 450px;
            }
            .header{
                display: flex;
                align-items: center;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
